import {
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GeneralButtonLabel,
  SettingsPageText,
  SnackbarMsg,
} from "../../data/texts";
import { Images } from "../../models/assets-files";
import { ImageService } from "../../services/image.service";
import { UserService } from "../../services/user.service";
import { StoreState } from "../../store/store";
import { showSnackbar } from "../../store/system.store";
import { StyledSettingsScreen } from "../../styled-cmps/settings-screen";
import Image from "../common/Image";
import useScreen from "../common/UseScreen";

const SecurityScreen = () => {
  const { isDesktop } = useScreen();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state: StoreState) => state.user.loggedInUser);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    repeatNewPassword: "",
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const hadleSubmit = async () => {
    try {
      setIsLoading(true);
      if (!user) return;
      const isUserValid = await UserService.checkUserInfoValid(
        user.email,
        formData.currentPassword
      );
      if (isUserValid && user) {
        await UserService.changePassword(user?.email, formData.newPassword);
        dispatch(showSnackbar({ msg: SnackbarMsg.PASSWORD_CHANGED }));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const imgBreakingPoint = useMediaQuery("(min-width: 1000px)");
  return (
    <StyledSettingsScreen
      sx={{ ...(isLoading ? theme.customStyles.disabled : "") }}
      flexDirection={isDesktop ? "row" : "column"}
    >
      {isLoading && (
        <CircularProgress
          sx={{ position: "absolute", top: "40%", left: "50%" }}
        />
      )}
      <Stack
        gap={"15px"}
        sx={{ width: isDesktop ? "40%" : "100%", marginBottom: "50px" }}
      >
        <Typography sx={{ fontWeight: "400", marginBottom: "20px" }}>
          {SettingsPageText.SECURITY}
        </Typography>
        <TextField
          name="currentPassword"
          onChange={handleChange}
          label={SettingsPageText.CURRENT_PASSWORD}
        />
        <TextField
          name="newPassword"
          onChange={handleChange}
          label={SettingsPageText.NEW_PASSWORD}
        />
        <TextField
          name="repeatNewPassword"
          onChange={handleChange}
          label={SettingsPageText.REPEAT_NEW_PASSWORD}
        />
        <Button onClick={hadleSubmit} variant="contained">
          {GeneralButtonLabel.SUBMIT}
        </Button>
      </Stack>
      <Image
        sx={{
          alignSelf: !isDesktop ? "center" : "unset",
          width: imgBreakingPoint ? "300px" : "200px",
          objectFit: "contain",
        }}
        src={ImageService.getLocalImgPath(
          Images.Folders.SETTINGS,
          Images.Settings.MAGNIFY_GLASS_SCREEN,
          "png"
        )}
      />
    </StyledSettingsScreen>
  );
};

export default SecurityScreen;
